import React from 'react';
import { createRoot } from 'react-dom/client';
import { APIProvider } from '@vis.gl/react-google-maps';
import { PortfolioMap } from './PortfolioMap';

const MOUNT_ID = 'portfolio-map-root';

const resolveApiKey = () => {
  if (
    typeof window !== 'undefined' &&
    window.BLUECURRENT_PORTFOLIO_MAP?.googleMapsApiKey
  ) {
    return window.BLUECURRENT_PORTFOLIO_MAP.googleMapsApiKey;
  }
  return process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
};

const mount = () => {
  const el = document.getElementById(MOUNT_ID);
  if (!el || el.dataset.portfolioMapMounted === '1') return;

  el.dataset.portfolioMapMounted = '1';
  const root = createRoot(el);

  root.render(
    <APIProvider apiKey={resolveApiKey()}>
      <PortfolioMap />
    </APIProvider>,
  );
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount, { once: true });
} else {
  mount();
}
